import React from 'react'

export default (props) => (
  <span className='tc'>
    &copy;Crown copyright {new Date().getFullYear()}.
    Legislation licensed under the terms of the Open Government Licence
    (<Link />).
  </span>
)

const Link = () => (
  <a
    href='http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3'
    target='_blank'
    rel='noopener noreferrer'
  >
    http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3
  </a>
)
